import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Cached across components so /site-content is only fetched once per session.
let _cache = null;

// Returns a sizeLabel(size) helper that appends the compact age group, e.g. "24 (3-4Y)".
// Falls back to the raw size string when no age match exists (e.g. "Crop top").
export function useSizeAgeMap() {
  const [map, setMap] = useState(_cache || {});
  useEffect(() => {
    if (_cache) { setMap(_cache); return; }
    api.get("/site-content").then((r) => {
      const m = {};
      (r.data?.size_guide?.tables || []).forEach((t) => {
        (t.rows || []).forEach((row) => {
          if (row?.size != null && row?.age_group) {
            m[String(row.size)] = String(row.age_group).replace(/ Years?/, "Y");
          }
        });
      });
      _cache = m;
      setMap(m);
    }).catch(() => {});
  }, []);
  return (s) => (map[String(s)] ? `${s} (${map[String(s)]})` : s);
}
